import { combineReducers } from 'redux'
import facets from './facets'
import layout from './layout'
import legislation from './legislation'
import page from './page'
import textEditor from './textEditor'
import legislationReference from './legislationReference'
import precedents from './precedents'
import qa from './qa'
import ca from './ca'
import user from './user'
import accordion from './accordion'
import dealwatch from './dealwatch'
import newsTicker from './newsTicker'
import placeholders from './placeholders'
import search from './search'
import cms from './cms'
import modals from './modals'
import annotations from './annotations'
import aol from './aol'
import faq from './faq'
import users from './users'

import { enableAllPlugins } from 'immer'

enableAllPlugins()

export default combineReducers({
  facets,
  layout,
  page,
  textEditor,
  legislationReference,
  legislation,
  qa,
  ca,
  precedents,
  user,
  accordion,
  dealwatch,
  newsTicker,
  placeholders,
  search,
  cms,
  modals,
  annotations,
  aol,
  faq,
  users
})
